import { get } from 'lodash'
import { fork, takeEvery, put, call, select } from 'redux-saga/effects'

import {
  GET_FEATURES_FOR_USER,
  getFeaturesForUser,
  getFeaturesForUserSucceeded,
  getFeaturesForUserFailed,
} from '../actions'
import { START_MANAGING_ORG } from 'auth/actions'
import { saveManagedOrgOverride } from 'auth/managedOrgOverride'
import { currentOrganization, currentUser } from 'auth/selectors'
import fetchFeaturesForOrg from '../fetchFeaturesForOrg'

export default function* developmentFeatureRootSaga() {
  yield fork(watchForStartManagingOrg)
  yield fork(watchForGetFeaturesEvents)
}

export function* watchForStartManagingOrg() {
  yield takeEvery(START_MANAGING_ORG, onStartManagingOrgEvent)
}

export function* onStartManagingOrgEvent(manageOrgEvent) {
  const { organization } = manageOrgEvent.payload
  const user = yield select(currentUser)
  saveManagedOrgOverride(user?.cognitoSub, organization.id)
  yield loadFeaturesForOrg(user, organization.id)
}

export function* watchForGetFeaturesEvents() {
  yield takeEvery(GET_FEATURES_FOR_USER, onGetFeaturesEvent)
}

export function* onGetFeaturesEvent(fetchEvent) {
  const { user, orgId: requestedOrgId } = fetchEvent.payload
  // The token keeps pointing at the user's own organization, so an internal admin who
  // switched organizations would get the wrong flags if we read the id from there.
  const organization = yield select(currentOrganization)
  const orgId = requestedOrgId ?? (get(organization, 'id') || get(user, 'permissions.managedOrganization.id'))
  yield loadFeaturesForOrg(user, orgId)
}

function* loadFeaturesForOrg(user, orgId) {
  const { features, error } = yield call(fetchFeaturesForOrg, orgId)
  yield put(error ? getFeaturesForUserFailed(user, error) : getFeaturesForUserSucceeded(user, features))
}

export function isSameUser(authorizedUser, featuresUser) {
  return authorizedUser != null && featuresUser != null && authorizedUser.cognitoSub === featuresUser.cognitoSub
}
